// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CitationModal-cls1___7b841837d528dee40d4{/*!*/}.CitationModal-cls2___9552ed26ac1739f172b{position:absolute;bottom:8px;right:8px;background-color:var(--brand-colors-success-500);color:var(--text-white);padding:2px 8px;border-radius:var(--corner-radius-radius-sm);font-size:var(--type-sizes-12)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CitationModal-cls1___7b841837d528dee40d4",
	"cls2": "CitationModal-cls2___9552ed26ac1739f172b CitationModal-cls1___7b841837d528dee40d4"
};
export default ___CSS_LOADER_EXPORT___;
